import { memo } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Tooltip
} from '@mui/material';

import { useVehicleConflictStore } from '../stores/useVehicleConflictStore';
import VehicleConflictItem from './VehicleConflictItem';

function VehicleConflictModal({
    open,
    onClose
}) {
    
    const root = useVehicleConflictStore(
        state => state.getRootNode()
    );

    const loadingConflicts = useVehicleConflictStore(
        state => state.loadingConflicts
    );

    const hasUndoChanges = useVehicleConflictStore(
        state => state.hasUndoChanges()
    );

    const undoConflictChanges = useVehicleConflictStore(
        state => state.undoConflictChanges
    );

    if (!root) {
        return null;
    }

    return (
        <Dialog
            open={open}
            onClose={loadingConflicts ? undefined : onClose}
            maxWidth="sm"
            fullWidth
            scroll="paper"
            disableRestoreFocus
            disableAutoFocus
            disableEnforceFocus
            PaperProps={{
                sx: (theme) => ({
                    ...theme.customStyles.modalPaper
                })
            }}
            TransitionProps={{
                onEntering: () => {
                    document.activeElement?.blur?.();
                },
                onExit: () => {
                    document.activeElement?.blur?.();
                },
            }}
        >
            <DialogTitle>
                Uso do veículo {root.newVehicle ?? root.originalVehicle}
            </DialogTitle>

            <DialogContent
                dividers
                sx={{ maxHeight: 450, overflowY: 'auto' }}
            >

                {root.children.map(childId => (

                    <VehicleConflictItem
                        key={childId}
                        tripId={childId}
                    />

                ))}

            </DialogContent>

            <DialogActions
                sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}
            >
                <Tooltip
                    title="
                        Remove todas as alterações de veículos
                        realizadas nesta janela e reinicia
                        a resolução de conflitos.
                    "
                >
                    <span>
                        <Button
                            color="error"
                            disabled={loadingConflicts || !hasUndoChanges}
                            onClick={undoConflictChanges}
                        >
                            Desfazer
                        </Button>
                    </span>
                </Tooltip>

                <Tooltip
                    title="
                        Mantém as alterações realizadas.
                        Caso ainda existam conflitos,
                        não será possível confirmar
                        a escala.
                    "
                >
                    <span>
                        <Button
                            variant="contained"

                            onClick={onClose}

                            disabled={loadingConflicts}
                        >
                            OK
                        </Button>
                    </span>
                </Tooltip>
            </DialogActions>

        </Dialog>
    );

}

export default memo(VehicleConflictModal);